const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const merge = require('lodash/fp/merge');

function parseAlternativesPosition(position) {
  return merge(
    parsePosition(position),
    {
      initialCommitment: position.psIntCmt,
      unfundedCommitment: position.psUnfCmt,
      purchaseValue: position.psAmt,
      totalCapitalCall: position.psTotCapCal,
      totalDistribution: position.psTotCapDis,
      capitalBalance: position.psCapBal,
      priceDate: position.psMktPrcDt,
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/alternatives/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '8',
    positionsUrl: 'alternatives-positions',
    transactionsUrl: 'alternatives-transactions',
    valueMovementUrl: 'alternatives-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseAlternativesPosition,
  });

  return routeAdderFactory({ assetType: 'alternatives', service });
}

module.exports = addRoutes;
